import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Spinner,
  Alert,
} from 'reactstrap';
import Select from 'react-select';
import Header from '../../components/Headers/Header.js';
import { axiosGet, axiosPost } from '../../util/apiConfig';

class EmailTemplates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classList: [],
      classId: '',
      template: null,
      emailType: '',
      subject: '',
      message: '',
      loadingTemplate: false,
      saving: false,
      successMsg: '',
      errorMsg: '',
    };
  }

  componentDidMount() {
    axiosGet('class/get-classes-list')
      .then((res) => {
        // class/get-classes-list puts the raw array straight on `data` (see
        // res.withResponse in the API), no `.result` wrapper.
        const list = (res && !res.isError && res.data) || [];
        this.setState({ classList: list });
        if (list[0] && list[0].classId) {
          this.setState({ classId: list[0].classId });
          this.getTemplate(list[0].classId);
        }
      })
      .catch(() => this.setState({ classList: [] }));
  }

  getTemplate = (classId) => {
    if (!classId) return;
    this.setState({ loadingTemplate: true, emailType: '', subject: '', message: '' });
    axiosGet(`email-template/${classId}`)
      .then((res) => {
        const doc = (res && !res.isError && res.data && res.data[0]) || null;
        this.setState({ template: doc, loadingTemplate: false });
      })
      .catch(() => this.setState({ template: null, loadingTemplate: false }));
  };

  onSelectClass = (classId) => {
    this.setState({ classId });
    this.getTemplate(classId);
  };

  onSelectEmailType = (emailType) => {
    const { template } = this.state;
    const block = (template && template.content && template.content[emailType]) || {};
    this.setState({ emailType, subject: block.subject || '', message: block.message || '' });
  };

  save = async () => {
    const { classId, emailType, subject, message } = this.state;
    if (!classId || !emailType) return;
    this.setState({ saving: true, successMsg: '', errorMsg: '' });
    const res = await axiosPost('email-template/update', { classId, emailType, subject, message });
    this.setState({ saving: false });
    if (!res.isError) {
      this.setState({ successMsg: 'Saved — this email now sends the updated copy immediately.' });
      this.getTemplate(classId);
    } else {
      this.setState({ errorMsg: res.message || 'Something went wrong. Try again later.' });
    }
  };

  render() {
    const { classList, classId, template, emailType, subject, message, loadingTemplate, saving, successMsg, errorMsg } = this.state;
    const classOptions = classList.map((c) => ({ value: c.classId, label: c.name }));
    const emailTypeOptions = template
      ? Object.keys(template.content || {}).sort().map((key) => ({ value: key, label: key }))
      : [];
    const selectedClassOption = classId ? classOptions.find((o) => o.value === classId) || null : null;
    const selectedEmailTypeOption = emailType ? { value: emailType, label: emailType } : null;

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Card className="shadow">
            <CardHeader className="border-0">
              <h3 className="mb-0">Email Templates</h3>
              <small className="text-muted">
                Edit subject/body copy per class and email type. Changes apply immediately, no deploy needed.
              </small>
            </CardHeader>
            <CardBody>
              {successMsg ? <Alert color="success">{successMsg}</Alert> : null}
              {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
              <Row>
                <Col md="6">
                  <FormGroup>
                    <label className="form-control-label">Class</label>
                    <Select
                      options={classOptions}
                      value={selectedClassOption}
                      placeholder="Select Class"
                      isSearchable
                      onChange={(e) => this.onSelectClass(e.value)}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <label className="form-control-label">Email type</label>
                    <Select
                      options={emailTypeOptions}
                      value={selectedEmailTypeOption}
                      placeholder={loadingTemplate ? 'Loading…' : 'Select email type'}
                      isDisabled={!template}
                      isSearchable
                      onChange={(e) => this.onSelectEmailType(e.value)}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {loadingTemplate ? (
                <div className="py-4 text-center"><Spinner /></div>
              ) : emailType ? (
                <>
                  <FormGroup>
                    <label className="form-control-label">Subject</label>
                    <Input value={subject} onChange={(e) => this.setState({ subject: e.target.value })} placeholder="Subject" />
                  </FormGroup>
                  <FormGroup>
                    <label className="form-control-label">Message body</label>
                    <Input
                      type="textarea"
                      rows="12"
                      value={message}
                      onChange={(e) => this.setState({ message: e.target.value })}
                      placeholder="Message body"
                      className="font-monospace"
                    />
                  </FormGroup>
                  <div className="text-right">
                    <Button color="primary" onClick={this.save} disabled={saving}>
                      {saving ? 'Saving…' : 'Save'}
                    </Button>
                  </div>
                </>
              ) : (
                <p className="text-muted">Select a class and an email type to edit its copy.</p>
              )}
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}

export default EmailTemplates;
